export const Paths = {
  HOME: 'home',
  PROFILE: 'profile',
  CHANGE_ALIAS: 'profile/change-alias',
  CHANGE_GROUP: 'profile/change-group',
  RIDDLE: 'riddle',
  RIDDLE_HISTORY: 'riddle/history',
  TASKS: 'tasks',
  NEWS: 'news',
  EVENTS: 'event',
  CALENDAR: 'calendar',
  IMPRESSUM: 'impressum',
  TOKEN: 'token',
  TOKEN_SCANNED: 'token-scanned',
  COMMUNITY: 'community',
  ORGANIZATION: 'organization',
  TINDER: 'tinder',
  ERROR: 'error',
  EXTRA_PAGE: 'page',
  FORM: 'form',
  LEADER_BOARD: 'leaderboard',
  KIRPAY_LEADERBOARD: 'kirpay-leaderboard',
  RACE: 'race',
  QR_FIGHT: 'qr-fight',
  BOUNTY: 'bounty',
  TEAMS: 'teams',
  CREATE_TEAM: 'create-team',
  EDIT_TEAM: 'edit-team',
  MY_TEAM: 'my-team',
  TEAM_ADMIN: 'team-admin',
  ACCESS_KEY: 'access-key',
  MAP: 'map',
  DEBT: 'debt',
  GALLERY: 'gallery',
  RESET_PASSWORD: 'reset-password',
  SUPPORT: 'support',
  LOGIN_ORG: 'login-org'
} as const
export type Paths = (typeof Paths)[keyof typeof Paths]

export const AbsolutePaths = {
  HOME: '/home',
  PROFILE: '/profile',
  CHANGE_ALIAS: '/profile/change-alias',
  CHANGE_GROUP: '/profile/change-group',
  RIDDLE: '/riddle',
  RIDDLE_HISTORY: '/riddle/history',
  TASKS: '/tasks',
  NEWS: '/news',
  EVENTS: '/event',
  IMPRESSUM: '/impressum',
  TOKEN: '/token',
  TOKEN_SCANNED: 'token-scanned',
  COMMUNITY: '/community',
  ORGANIZATION: '/organization',
  TINDER: '/tinder',
  ERROR: '/error',
  EXTRA_PAGE: '/page',
  FORM: '/form',
  RACE: '/race',
  TEAMS: '/teams',
  CREATE_TEAM: '/create-team',
  EDIT_TEAM: '/edit-team',
  MY_TEAM: '/my-team',
  TEAM_ADMIN: '/team-admin',
  QR_FIGHT: '/qr-fight',
  BOUNTY: '/bounty',
  LEADER_BOARD: '/leaderboard',
  KIRPAY_LEADERBOARD: '/kirpay-leaderboard',
  ACCESS_KEY: '/access-key',
  MAP: '/map',
  DEBT: '/debt',
  GALLERY: '/gallery',
  RESET_PASSWORD: '/reset-password',
  SUPPORT: '/support'
} as const
export type AbsolutePaths = (typeof AbsolutePaths)[keyof typeof AbsolutePaths]

export const ApiPaths = {
  CONFIG: '/api/app',
  EVENTS: '/api/events',
  FORM: '/api/form',
  PAGE: '/api/page',
  NEWS: '/api/news',
  RACE: '/api/race',
  FREESTYLE_RACE: '/api/freestyle-race',
  RACE_BY_TEAM: '/api/race-by-team',
  RIDDLE: '/api/riddle',
  RIDDLE_HISTORY: '/api/riddle-history',
  TASK: '/api/task',
  TASK_SUBMIT: '/api/task/submit',
  REFRESH: '/api/control/refresh',
  WARNING: '/api/warning',
  TASK_CATEGORY: '/api/task/category',
  PROFILE: '/api/profile',
  WHO_AM_I: '/api/whoami',
  LEVELS: '/api/levels',
  LOCATION: '/api/track-my-group',
  TOKENS: '/api/tokens',
  CHANGE_ALIAS: '/api/profile/change-alias',
  CHANGE_GROUP: '/api/group/select',
  COMMUNITY: '/api/community',
  ORGANIZATION: '/api/organization',
  TINDER: '/api/tinder/community',
  TINDER_QUESTION: '/api/tinder/question',
  TINDER_ANSWERS: '/api/tinder/question/answers',
  TINDER_INTERACTION: '/api/tinder/community/interact',
  ACCESS_KEY: '/api/access-key',
  HOME_NEWS: '/api/home/news',
  GALLERY: '/api/gallery',
  HOME_GALLERY: '/api/gallery/home',
  ADD_PUSH_NOTIFICATION_TOKEN: '/api/pushnotification/add-token',
  DELETE_PUSH_NOTIFICATION_TOKEN: '/api/pushnotification/delete-token',
  MY_TEAM: '/api/team/my',
  TEAM: '/api/team',
  ALL_TEAMS: '/api/teams',
  DEBTS: '/api/debts',
  KIRPAY_LEADERBOARD: '/api/kirpay-leaderboard',
  LOGIN: '/api/login',
  REGISTER: '/api/register',
  FORGOT_PASSWORD: '/api/forgot-password',
  RESET_PASSWORD: '/api/reset-password',
  AUTH_STATUS: '/api/auth-status',
  SUPPORT_THREADS: '/api/support/threads',
  SUPPORT_THREAD: '/api/support/thread',
  BOUNTY: '/api/bounty',
  BOUNTY_KILL: '/api/bounty/kill'
} as const
export type ApiPaths = (typeof ApiPaths)[keyof typeof ApiPaths]
